
<p-dialog header="Sending Data to One Codex/Internal storage" [(visible)]="sendingData" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">
        Sending data to One Codex/Internal storage, please wait.  This operation can take a few minutes.
    </p>
</p-dialog>
<p-card>
    <!--[rows]="50" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" 
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" if we want to include paging-->
    <p-table [value]="sampleList" [tableStyle]="{'min-width': '50rem'}" #dt [loading]="loading" [columns]="cols"
        stateStorage="local" stateKey="samplelist-state">
        <ng-template pTemplate="caption">
            <div class="">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <button type="button" pButton icon="pi pi-envelope" iconPos="left" label="Send results ready email" (click)="sendCompleteEmail()" style="float:right;"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Name
                        <p-sortIcon field="name"></p-sortIcon>
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="normalizedPlate" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Normalized Plate
                        <p-sortIcon field="normalizedPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="normalizedPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="libraryPlate" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Library Plate
                        <p-sortIcon field="libraryPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="libraryPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="isControl" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Control
                        <p-sortIcon field="isControl"></p-sortIcon>
                        <p-columnFilter type="text" field="isControl" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="yield" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Total Read Count
                        <p-sortIcon field="yield"></p-sortIcon>
                        <p-columnFilter type="numeric" field="yield" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="qualityScore" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Quality
                        <p-sortIcon field="qualityScore"></p-sortIcon>
                        <p-columnFilter type="numeric" field="qualityScore" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="approvalDate" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Approval Date
                        <p-sortIcon field="approvalDate"></p-sortIcon>
                        <p-columnFilter type="date" field="approvalDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="retestDate" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Retest Date
                        <p-sortIcon field="retestDate"></p-sortIcon>
                        <p-columnFilter type="date" field="retestDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sentToOC" style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Sent To OC/Storage
                        <p-sortIcon field="sentToOC"></p-sortIcon>
                        <p-columnFilter type="text" field="sentToOC" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        View QC
                    </div>
                </th>
                <th style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Approve
                    </div>
                </th>
                <th style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Retest
                    </div>
                </th>
                <th  style="min-width:5rem">
                    <div class="flex justify-content-center align-items-center">
                        Send
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sample>
            <tr (click)="rowClick(sample)">
                <td>{{sample.name}}</td>
                <td>{{sample.normalizedPlate}}</td>
                <td>{{sample.libraryPlate}}</td>
                <td>{{sample.isControl}}</td>
                <td>{{sample.yield | number}}</td>
                <td>{{sample.qualityScore | number}}</td>
                <td>{{sample.approvalDate | date:'short'}}</td>
                <td>{{sample.retestDate | date:'short'}}</td>
                <td>{{sample.sentToOC}}</td>
                <td><button pButton type="button" label="View QC" (click)="viewQC(sample)"></button></td>
                <td><button pButton [disabled]="!sample.isOpen" type="button" label="Approve" (click)="approve(sample)"></button></td>
                <td><button pButton [disabled]="sample.isRetested" type="button" label="Retest" (click)="retest(sample)"></button></td>
                <td><button pButton [disabled]="!sample.isApproved || sample.sentToOC" type="button" label="Send to OC/Storage" (click)="sendSampleToOC(sample)"></button></td>
            </tr>
        </ng-template>
    </p-table>
</p-card>